import { FC, PropsWithChildren } from 'react'
import { FluentIcon } from '@fluentui/react-icons'
import { Trans } from 'react-i18next'
import { cn } from '@opoint/infomedia-storybook'

type Props = PropsWithChildren<{
  primaryText: string
  secondaryText: string
  statusCode?: number
  className?: string
  icon: FluentIcon
}>

const ErrorPage: FC<Props> = ({ primaryText, secondaryText, statusCode, icon: PropsIcon, children }) => (
  <div className="flex size-full flex-col items-center justify-center gap-6 text-center">
    <div className="flex size-24 shrink-0 items-center justify-center rounded-full bg-sky.8">
      <PropsIcon className="size-16 text-sky.cloudy" />
    </div>
    <div className="max-w-md">
      <p className={cn('mb-1 text-heading-1 text-sky.1', { 'mb-3': !statusCode })}>{primaryText}</p>

      {!!statusCode && (
        <span className="mb-3 block text-sm text-sky.cloudy ">
          <Trans>Error code: {statusCode}</Trans>
        </span>
      )}

      <p className="mb-0 text-sm text-sky.1">{secondaryText}</p>
    </div>

    {children}
  </div>
)

export default ErrorPage
